<ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>
<ng-template #legendTemplate>

    <ct-button *ngIf="paymentConfiguration.visible" [configuration]="exportDownloadAttachmentButton"></ct-button>
    
  </ng-template>
  